import { render, staticRenderFns } from "./WonderYjjRate.vue?vue&type=template&id=0fb8f7a0"
import script from "./WonderYjjRate.vue?vue&type=script&lang=js"
export * from "./WonderYjjRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports